import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import {
  GetSwConfigVariablesResult,
  GetSwConfigVariablesVar,
  SwConfigQueryType,
  SwConfigVariables,
  UpdateSwConfigVariablesData,
  UpdateSwConfigVariablesVar
} from "../masters/items/configurations/queries/type";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSwConfigVariables } from "../masters/items/configurations/queries/queries";
import { EMPTY_STRING, emptyMessage } from "../../../../utils/constants";
import { LicenseTypes, Operation, PageFor } from "../../../../utils/Enum.types";

import useUrlParams from "../../../../customHooks/useUrlParams";
import { UpdateSwConfigVariables } from "../masters/items/configurations/queries/mutations";
import LoadingModal from "../../../pages/LoadingModal";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../stories/Button/Button";
import { Title } from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "../../../../styles/AccordionStyles";
import { FormControlLabel, FormGroup, Typography } from "@mui/material";
import { AntSwitch } from "../../../../styles/Switch";
import { Label } from "../../../../stories/Label/Label";
import Input from "../../../../stories/Input/Input";
import { Select } from "../../../../stories/Select/Select";
import MessageModal from "../../../../customComponents/MessageModal";
import Navbar from "../../../common/layout/Navbar";
import { modalOpertaionFlag } from "../../customer/Index";
import Steps from "../../customer/Steps";
import { AppContext } from "../../../../context/context";
import {
  GetSwConfigReferenceDataByKeyResult,
  GetSwConfigReferenceDataByKeyVar,
  SoftwareConfigTypeList,
  SoftwareConfigTypeVar
} from "./queries/types";
import {
  GetSwConfigReferenceData,
  GetSwConfigReferenceDataByKey
} from "./queries/queries";

interface Props {
  setModalFlag?: React.Dispatch<React.SetStateAction<modalOpertaionFlag>>;
  pageType: PageFor;
  queryType: SwConfigQueryType;
  steps?: boolean;
}
const AssetConfiguration = ({
  setModalFlag,
  pageType,
  queryType,
  steps
}: Props) => {

  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { state } = useContext(AppContext);
  const navigate = useNavigate();

  const [pageSwDetails, setPageSwConfigList] = useState<SwConfigVariables[]>(
    []
  );

  const [message, setMessage] = useState(emptyMessage);

  const [expanded, setExpanded] = useState<string | false>("");
  const handleChange =
    (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const [
    GetSwVariablesData,
    { data: SwConfigVariablesData, loading: GetSwConfigVariablesLoding }
  ] = useLazyQuery<GetSwConfigVariablesResult, GetSwConfigVariablesVar>(
    GetSwConfigVariables
  );

  const [GetSwConfigReference, { data: OptionsData }] = useLazyQuery<
    SoftwareConfigTypeList,
    SoftwareConfigTypeVar
  >(GetSwConfigReferenceData);

  const [
    getSwConfigReferenceDataByKey,
    { data: GetSwConfigReferenceDataByKeyData }
  ] = useLazyQuery<
    GetSwConfigReferenceDataByKeyResult,
    GetSwConfigReferenceDataByKeyVar
  >(GetSwConfigReferenceDataByKey);

  const [updateSwConfig, { loading: updateLoading }] = useMutation<
    UpdateSwConfigVariablesData,
    UpdateSwConfigVariablesVar
  >(UpdateSwConfigVariables, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE
      });
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
     
        if (customer_id || state.customerId) {
          GetSwVariablesData({
            variables: {
           
              customerID: customer_id ? customer_id : state.customerId,
              input: {
                queryType
              }
            }
          }).then(({ data }) => {
            if (data) {
              setPageSwConfigList(data.GetSwConfigVariables);
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, state.customerId, GetSwVariablesData]);

  const groupedPageSwDetails: { [key: string]: SwConfigVariables[] } =
    pageSwDetails.reduce((groups, item) => {
      const { module } = item;
      if (!groups[module]) {
        groups[module] = [];
      }
      groups[module].push(item);
      return groups;
    }, {} as { [key: string]: SwConfigVariables[] });

  const handleChangeValue = (
    key: string,
    type:
      | "BOOL"
      | "INT"
      | "primary_list_key"
      | "secondary_list_key"
      | "VARCHAR"
      | "VARCHAR2",
    switchValue?: boolean | null,
    selectedValue?: string | null
  ) => {
    if (type === "BOOL") {
      const newState =
        pageSwDetails &&
        // eslint-disable-next-line
        pageSwDetails.map((obj) =>
          obj.configKey === key ? { ...obj, booleanValue: switchValue! } : obj
        );
      setPageSwConfigList(newState);
    }

    if (type === "INT") {
      const newState = pageSwDetails.map((obj) =>
        obj.configKey === key
          ? { ...obj, integerValue: Number(selectedValue)! }
          : obj
      );
      setPageSwConfigList(newState);
    }
    if (type === "primary_list_key") {
      const configKey = key + "_" + selectedValue!;
      const newState = pageSwDetails.map((obj) =>
        obj.configKey === key
          ? {
              ...obj,
              config_secondary_list_key: configKey,
              str1Value: selectedValue!
            }
          : obj
      );
      setPageSwConfigList(newState);
    }

    if (type === "secondary_list_key") {
      const newState = pageSwDetails.map((obj) =>
        obj.configKey === key ? { ...obj, str2Value: selectedValue! } : obj
      );
      setPageSwConfigList(newState);
    }

    if (type === "VARCHAR") {
      const newState = pageSwDetails.map((obj) =>
        obj.configKey === key ? { ...obj, str1Value: selectedValue! } : obj
      );
      setPageSwConfigList(newState);
    }

    if (type === "VARCHAR2") {
      const newState = pageSwDetails.map((obj) =>
        obj.configKey === key ? { ...obj, str2Value: selectedValue! } : obj
      );
      setPageSwConfigList(newState);
    }
  };

  const handleUpdateSwConfig = async () => {
    try {
      
   
        if (customer_id || state.customerId) {
          const updateConfig = updateSwConfig({
            variables: {
             
              customerID: customer_id ? customer_id : state.customerId,
              input: pageSwDetails.map((pageSwDetail) => ({
                id: pageSwDetail.id!,
                config_key: pageSwDetail.configKey,
                booleanValue: pageSwDetail.booleanValue,
                integerValue: pageSwDetail.integerValue,
                doubleValue: pageSwDetail.doubleValue,
                str1Value: pageSwDetail.str1Value,
                str2Value: pageSwDetail.str2Value,
                dateValue: pageSwDetail.dateValue
              })),
              user_details
            },
            refetchQueries: [
              {
                query: GetSwConfigVariables,
                variables: {
              
                  customerID: customer_id ? customer_id : state.customerId,
                  input: {
                    queryType: SwConfigQueryType.ALL_CONFIGS,
                    strValue: EMPTY_STRING,
                    intValue: 0
                  }
                }
              }
            ]
          });

          const { data } = await updateConfig;
          if (data) {
            setMessage({
              flag: true,
              message: "Configuration Saved Successfully",
              operation: Operation.CREATE
            });
            setExpanded(false);
          }
        }
      
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE
      });
    }
  };
  const handleClose = () => {
    setMessage({
      flag: false,
      message: "",
      operation: Operation.NONE
    });
  };

  const instTypeData = (type: string) => {
    const typeData =
      GetSwConfigReferenceDataByKeyData?.GetSwConfigReferenceDataByKey;

    return typeData?.list
      .split(";")
      .map((d) => ({
        label: d.split(":")[0],
        value: d.split(":")[1]
      }))
      .filter(({ value }) => value !== undefined);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
     
      
          GetSwConfigReference();
        
      } catch (error) {
        console.error((error as Error).message);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
  
     
          getSwConfigReferenceDataByKey({
            variables: {
          
              config_key: "SQL_NUMBER_LEVEL"
            }
          });
        
      } catch (error) {
        console.error((error as Error).message);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {pageType === PageFor.VIEW ? (
        <>
          <Navbar NavType={LicenseTypes.CONFIG} />
          <Title>Configurations</Title>
          {steps && <Steps step={3} />}
        </>
      ) : pageType === PageFor.MODAL ? (
        <>
          <div className="customer__add--title">
            <Title>Configurations</Title>

            <img
              src={Close}
              alt=""
              onClick={() => {
                if (setModalFlag) {
                  setModalFlag({
                    flag: false,
                    operation: Operation.CREATE
                  });
                }
              }}
            />
          </div>
        </>
      ) : (
        <>
          <Navbar NavType={LicenseTypes.CONFIG} />
          <Title>Configurations</Title>
        </>
      )}

      <div
        className={
          pageType === PageFor.MODAL
            ? "configurations__edit"
            : pageType === PageFor.VIEW
            ? "configurations__steps"
            : "configurations"
        }
      >
        <div className="configurations__list">
          <div className="configurations__list--details">
            {Object.keys(groupedPageSwDetails).map(
              (label: string, index: number) => {
                const moduleItems = groupedPageSwDetails[label];
                return (
                  <React.Fragment key={index}>
                    <Accordion
                      expanded={expanded === label}
                      onChange={handleChange(label)}
                      key={index}
                    >
                      <AccordionSummary>
                        &nbsp;
                        <Typography component={"span"} variant={"body2"}>
                          {label}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography component={"span"} variant={"body2"}>
                          {moduleItems.map((list, index) => (
                            <div
                              className="configurations__list--parameters"
                              key={index}
                            >
                              <Label>
                                {index + 1} &nbsp;
                                {list.formLabelCaption}
                              </Label>

                              {list.dataStorageType ===
                              "BOOLEAN+SELECT+VARCHAR+ACCTLDGR" ? (
                                <>
                                  <div>
                                    <FormGroup>
                                      <FormControlLabel
                                        label=""
                                        labelPlacement="start"
                                        control={
                                          <AntSwitch
                                            checked={list.booleanValue}
                                            onClick={() => {
                                              const newConfigValue =
                                                !list.booleanValue;
                                              handleChangeValue(
                                                list.configKey,
                                                "BOOL",
                                                newConfigValue,
                                                null
                                              );
                                            }}
                                          />
                                        }
                                      />
                                    </FormGroup>
                                  </div>
                                  {list.booleanValue ? (
                                    <div>
                                      <div>
                                        <Select
                                          value={list.str1Value}
                                          onChange={(
                                            e: React.ChangeEvent<HTMLInputElement>
                                          ) => {
                                            handleChangeValue(
                                              list.configKey,
                                              "primary_list_key",
                                              null,
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {/* {instTypeData(list.primaryListKey)?.map(
                                          ({ label, value }) => (
                                            <React.Fragment key={value}>
                                              <option value={value}>
                                                {label}
                                              </option>
                                            </React.Fragment>
                                          )
                                        )} */}
                                        </Select>
                                      </div>
                                      <div className="row">
                                        <Label>Key: </Label>
                                        <Input
                                          value={list.str2Value}
                                          onChange={(
                                            e: React.ChangeEvent<HTMLInputElement>
                                          ) =>
                                            handleChangeValue(
                                              list.configKey,
                                              "VARCHAR2",
                                              null,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <div>
                                        <Label>
                                          Default Bank for Student online
                                          transaction:{" "}
                                        </Label>
                                        <Select
                                          value={list.integerValue}
                                          onChange={(
                                            e: React.ChangeEvent<HTMLInputElement>
                                          ) => {
                                            handleChangeValue(
                                              list.configKey,
                                              "INT",
                                              null,
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {/* {responseType.map(
                                          ({ label, value }) => (
                                            <React.Fragment key={value}>
                                              <option value={value}>
                                                {label}
                                              </option>
                                            </React.Fragment>
                                          )
                                        )} */}
                                        </Select>
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              ) : null}
                              {list.booleanValue &&
                              list.dependsOnPrimaryList &&
                              list.dataStorageType ===
                                "BOOLEAN+SELECT+VARCHAR" ? (
                                <>
                                  <div>
                                    <FormGroup>
                                      <FormControlLabel
                                        label=""
                                        labelPlacement="start"
                                        control={
                                          <AntSwitch
                                            checked={list.booleanValue}
                                            onClick={() => {
                                              const newConfigValue =
                                                !list.booleanValue;
                                              handleChangeValue(
                                                list.configKey,
                                                "BOOL",
                                                newConfigValue,
                                                null
                                              );
                                            }}
                                          />
                                        }
                                      />
                                    </FormGroup>
                                  </div>
                                  <div>
                                    <div>
                                      <Select
                                        value={list.str1Value}
                                        onChange={(
                                          e: React.ChangeEvent<HTMLInputElement>
                                        ) => {
                                          handleChangeValue(
                                            list.configKey,
                                            "primary_list_key",
                                            null,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        {/* {instTypeData(list.primaryListKey)?.map(
                                        ({ label, value }) => (
                                          <React.Fragment key={value}>
                                            <option value={value}>
                                              {label}
                                            </option>
                                          </React.Fragment>
                                        )
                                      )} */}
                                      </Select>
                                    </div>
                                    <div>
                                      <Select
                                        value={list.str1Value}
                                        onChange={(
                                          e: React.ChangeEvent<HTMLInputElement>
                                        ) => {
                                          handleChangeValue(
                                            list.configKey,
                                            "primary_list_key",
                                            null,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        {/* {instTypeData(list.primaryListKey)?.map(
                                        ({ label, value }) => (
                                          <React.Fragment key={value}>
                                            <option value={value}>
                                              {label}
                                            </option>
                                          </React.Fragment>
                                        )
                                      )} */}
                                      </Select>
                                    </div>
                                    <div>
                                      <Input
                                        value={list.str2Value}
                                        onChange={(
                                          e: React.ChangeEvent<HTMLInputElement>
                                        ) =>
                                          handleChangeValue(
                                            list.configKey,
                                            "VARCHAR2",
                                            null,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : null}

                              {list.dependsOnPrimaryList &&
                              !list.dependsOnSecondaryList &&
                              list.dataStorageType !== "BOOLEAN+SELECT" &&
                              list.dataStorageType !==
                                "BOOLEAN+SELECT+VARCHAR+ACCTLDGR" ? (
                                <div>
                                  <Select
                                    value={list.str1Value}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleChangeValue(
                                        list.configKey,
                                        "primary_list_key",
                                        null,
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {/* {instTypeData(list.primaryListKey)?.map(
                                    ({ label, value }) => (
                                      <React.Fragment key={value}>
                                        <option value={value}>{label}</option>
                                      </React.Fragment>
                                    )
                                  )} */}
                                  </Select>
                                </div>
                              ) : null}
                              {list.dependsOnPrimaryList &&
                              list.dependsOnSecondaryList &&
                              list.dataStorageType !== "BOOLEAN+SELECT" &&
                              list.dataStorageType !==
                                "BOOLEAN+SELECT+VARCHAR+ACCTLDGR" ? (
                                <div>
                                  <Select
                                    value={list.str1Value}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleChangeValue(
                                        list.configKey,
                                        "primary_list_key",
                                        null,
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {/* {instTypeData(list.primaryListKey)?.map(
                                    ({ label, value }) => (
                                      <React.Fragment key={value}>
                                        <option value={value}>{label}</option>
                                      </React.Fragment>
                                    )
                                  )} */}
                                  </Select>
                                </div>
                              ) : null}
                              {list.dependsOnPrimaryList &&
                              list.dependsOnSecondaryList &&
                              list.dataStorageType !== "BOOLEAN+SELECT" &&
                              list.dataStorageType !==
                                "BOOLEAN+SELECT+VARCHAR+ACCTLDGR" ? (
                                <div>
                                  <Select
                                    value={list.str2Value}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleChangeValue(
                                        list.configKey,
                                        "secondary_list_key",
                                        null,
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {/* {instTypeData(
                                    list.config_secondary_list_key
                                  )?.map(({ label, value }) => (
                                    <React.Fragment key={value}>
                                      <option value={value}>{label}</option>
                                    </React.Fragment>
                                  ))} */}
                                  </Select>
                                </div>
                              ) : null}

                              {list.dependsOnPrimaryList &&
                              list.dependsOnSecondaryList &&
                              list.dataStorageType === "SELECT" ? (
                                <div>
                                  <div>
                                    <Select
                                      value={list.str1Value}
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        handleChangeValue(
                                          list.configKey,
                                          "primary_list_key",
                                          null,
                                          e.target.value
                                        );
                                      }}
                                    >
                                      {/* {instTypeData(list.primaryListKey)?.map(
                                        ({ label, value }) => (
                                          <React.Fragment key={value}>
                                            <option value={value}>
                                              {label}
                                            </option>
                                          </React.Fragment>
                                        )
                                      )} */}
                                      <option>hdfc1</option>
                                      <option>hdfc2</option>
                                    </Select>
                                  </div>
                                  <div>
                                    <Label>Institution Working Type</Label>
                                    <Select
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        handleChangeValue(
                                          list.configKey,
                                          "secondary_list_key",
                                          null,
                                          e.target.value
                                        );
                                      }}
                                    >
                                      {/* {institutionWorkingtypeData.map(
                                      ({ label, value }) => (
                                        <React.Fragment key={value}>
                                          <option value={value}>{label}</option>
                                        </React.Fragment>
                                      )
                                    )} */}
                                    </Select>
                                  </div>
                                </div>
                              ) : null}

                              {list.dependsOnPrimaryList &&
                              list.dataStorageType === "VARCHAR+SELECT" ? (
                                <div>
                                  <div>
                                    <Select
                                      value={list.str1Value}
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        handleChangeValue(
                                          list.configKey,
                                          "primary_list_key",
                                          null,
                                          e.target.value
                                        );
                                      }}
                                    >
                                      {instTypeData(list.primaryListKey)?.map(
                                        ({ label, value }) => (
                                          <React.Fragment key={value}>
                                            <option value={value}>
                                              {label}
                                            </option>
                                          </React.Fragment>
                                        )
                                      )}
                                    </Select>
                                  </div>
                                </div>
                              ) : null}

                              {list.dataStorageType === "BOOLEAN" ? (
                                <FormGroup>
                                  <FormControlLabel
                                    label=""
                                    labelPlacement="start"
                                    control={
                                      <AntSwitch
                                        checked={list.booleanValue}
                                        onClick={() => {
                                          const newConfigValue =
                                            !list.booleanValue;
                                          handleChangeValue(
                                            list.configKey,
                                            "BOOL",
                                            newConfigValue,
                                            null
                                          );
                                        }}
                                      />
                                    }
                                  />
                                </FormGroup>
                              ) : null}
                              {list.dataStorageType === "BOOLEAN+VARCHAR" ? (
                                <FormGroup>
                                  <FormControlLabel
                                    label=""
                                    labelPlacement="start"
                                    control={
                                      <AntSwitch
                                        checked={list.booleanValue}
                                        onClick={() => {
                                          const newConfigValue =
                                            !list.booleanValue;
                                          handleChangeValue(
                                            list.configKey,
                                            "BOOL",
                                            newConfigValue,
                                            null
                                          );
                                        }}
                                      />
                                    }
                                  />
                                  {list.booleanValue && (
                                    <Input
                                      placeholder=""
                                      value={list.str1Value}
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) =>
                                        handleChangeValue(
                                          list.configKey,
                                          "VARCHAR",
                                          null,
                                          e.target.value
                                        )
                                      }
                                    />
                                  )}
                                </FormGroup>
                              ) : null}
                              {list.dataStorageType === "BOOLEAN+SELECT" ? (
                                <FormGroup>
                                  <FormControlLabel
                                    label=""
                                    labelPlacement="start"
                                    control={
                                      <AntSwitch
                                        checked={list.booleanValue}
                                        onClick={() => {
                                          const newConfigValue =
                                            !list.booleanValue;
                                          handleChangeValue(
                                            list.configKey,
                                            "BOOL",
                                            newConfigValue,
                                            null
                                          );
                                        }}
                                      />
                                    }
                                  />
                                  {list.dependsOnPrimaryList &&
                                  !list.dependsOnSecondaryList &&
                                  list.booleanValue ? (
                                    <div>
                                      <Select
                                        value={list.str1Value}
                                        onChange={(
                                          e: React.ChangeEvent<HTMLInputElement>
                                        ) => {
                                          handleChangeValue(
                                            list.configKey,
                                            "primary_list_key",
                                            null,
                                            e.target.value
                                          );
                                        }}
                                      >
                                        {/* {instTypeData(
                                          list.primaryListKey
                                        )?.map(({ label, value }) => (
                                          <React.Fragment key={value}>
                                            <option value={value}>
                                              {label}
                                            </option>
                                          </React.Fragment>
                                        ))} */}
                                      </Select>
                                    </div>
                                  ) : null}
                                </FormGroup>
                              ) : null}
                              {list.dependsOnPrimaryList === false &&
                              list.dataStorageType === "VARCHAR" ? (
                                <Input
                                  value={list.str1Value}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) =>
                                    handleChangeValue(
                                      list.configKey,
                                      "VARCHAR",
                                      null,
                                      e.target.value
                                    )
                                  }
                                />
                              ) : null}
                              {list.dataStorageType === "INT" ? (
                                <div className="label-grid">
                                  <Input
                                    type="number"
                                    value={list.integerValue}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) =>
                                      handleChangeValue(
                                        list.configKey,
                                        "INT",
                                        null,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              ) : null}
                            </div>
                          ))}
                          <Button mode="save" onClick={handleUpdateSwConfig} />
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </React.Fragment>
                );
              }
            )}
          </div>
        </div>

        {pageType === PageFor.VIEW && (
          <>
            {steps ? (
              <Button
                mode="move-next"
                type="button"
                onClick={() => navigate(`/${customer_id}/adduserdetails`)}
              />
            ) : (
              ""
            )}
          </>
        )}
        {pageType === PageFor.MODAL ? (
          <Button
            mode="cancel"
            onClick={() => {
              if (setModalFlag) {
                setModalFlag({
                  flag: false,
                  operation: Operation.CREATE
                });
              }
            }}
          />
        ) : (
          <Button mode="back" onClick={() => navigate(-1)} />
        )}
      </div>
      <LoadingModal flag={updateLoading || GetSwConfigVariablesLoding} />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default AssetConfiguration;
